// extracted by mini-css-extract-plugin
export default {"title":"lm1rI4","align-center":"sKfPB3","alignCenter":"sKfPB3"};